import groupBy from 'lodash/groupBy'
import { type ReactNode } from 'react'
import { IFlatMetadata } from 'react-accessible-treeview/dist/TreeView/utils'
import { useCompactViewport } from '~/hooks/useCompactViewport'
import { ControlledExpandedNode, ITreeNode } from '../../common/TreeView'
import { useReviewHistory } from './hooks'

interface ReviewHistoryProps {
  title: string
  actions?: ReactNode
}

export function ReviewHistory({ title, actions }: ReviewHistoryProps) {
  const reviewItems = useReviewHistory()
  const isCompactViewport = useCompactViewport()

  return (
    <div className='review-history w-full min-w-0'>
      <div className='mb-2 flex flex-wrap items-center justify-between gap-2'>
        <h2 className={isCompactViewport ? 'text-base font-semibold' : 'text-lg font-semibold'}>
          {title}
        </h2>
        {actions && <div className='flex shrink-0 items-center gap-2'>{actions}</div>}
      </div>
      <div className='review-content max-w-full overflow-hidden'>
        <ControlledExpandedNode
          node={
            reviewItems.length
              ? {
                  name: '',
                  children: reviewItems.reverse().map(item => {
                    let children = [
                      { name: ' No inline comments', children: [] }
                    ] as ITreeNode<IFlatMetadata>[]
                    if (
                      Array.isArray(item.review.diffComments) &&
                      item.review.diffComments.length > 0
                    ) {
                      const inlineComments = groupBy(item.review.diffComments, 'filePath')
                      children = Object.keys(inlineComments).map(filePath => {
                        return {
                          name: filePath || 'No file path',
                          children: inlineComments[filePath].map(comment => {
                            return {
                              name: `${comment.startLineNumber}-${comment.endLineNumber}: ${comment.comment}`,
                              children: []
                            }
                          })
                        }
                      }) as unknown as ITreeNode<IFlatMetadata>[]
                    }
                    return {
                      name: item.review.generalDiffComment || 'No general comment',
                      children
                    }
                  })
                }
              : null
          }
        />
      </div>
    </div>
  )
}
